import { Box } from "@mui/material";
import React from "react";

export const defaultFemaleWage = {
  Category: "Gross wages paid to females as % of total wages",
  currentFY: "",
  previousFY: "",
};

const FemaleWagePercentageTable = ({ femaleWageData, setFemaleWageData }) => {
  const handleChange = (field, value) => {
    setFemaleWageData({
      ...femaleWageData,
      Category: "Gross wages paid to females as % of total wages",
      [field]: value,
    });
  };

  return (
    <Box
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE" }}>
            <th style={cellHeader}></th>
            <th style={cellHeader}>Current FY</th>
            <th style={cellHeader}>Previous FY</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={labelCell}>
              Gross wages paid to females as % of total wages
            </td>
            <td style={cell}>
              <input
                type="text"
                placeholder="Enter"
                value={femaleWageData.currentFY}
                onChange={(e) => handleChange("currentFY", e.target.value)}
                style={inputStyle}
              />
            </td>
            <td style={cell}>
              <input
                type="text"
                placeholder="Enter"
                value={femaleWageData.previousFY}
                onChange={(e) => handleChange("previousFY", e.target.value)}
                style={inputStyle}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </Box>
  );
};

// Styles
const cellHeader = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#D3C9CE",
};

const labelCell = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#D3C9CE",
};

const cell = {
  border: "1px solid #ccc",
  padding: "15px",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "15px",
  borderRadius: "4px",
  border: "1px solid gray",
};

export default FemaleWagePercentageTable;
